/**
 * Utility function to validate if a value should be included in installation data
 */
export function isValidInstallationValue(value: string | number | null | undefined): boolean {
  return value !== null && value !== undefined && value !== '';
}

/**
 * Utility function to format installation data value to string
 */
export function formatInstallationValue(value: string | number | null | undefined): string {
  if (!isValidInstallationValue(value)) {
    return '';
  }
  return String(value);
}
